<template>
    <div>
        <div class="table-responsive">
            <table class="table table-striped table-bordered">
                <thead class="table-light">
                    <tr>
                        <th style="width: 50%">Dashboard Alerts</th>
                        <th style="width: 50%">Survey Alerts</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style="vertical-align: top">
                            <table v-if="dashboardAlerts.length" class="sub-table">
                                <thead>
                                    <tr>
                                        <th style="white-space: nowrap">Label</th>
                                        <th style="white-space: nowrap">Min/Max Rating</th>
                                        <th style="white-space: nowrap">Sentiment Group</th>
                                        <th style="white-space: nowrap">Sources</th>
                                        <th style="white-space: nowrap">Response Status</th>
                                        <th style="white-space: nowrap">Team Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(alert, index) in dashboardAlerts" :key="index">
                                        <td>{{ alert.label }}</td>
                                        <td>{{ alert.min_rating || 'Any' }} - {{ alert.max_rating || 'Any' }}  </td>
                                        <td>{{ alert.sentiment_group || 'All' }}</td>
                                        <td class="font-weight-bold text-primary">
                                            {{ getFormattedSources(alert.sources) || 'Any' }}
                                        </td>
                                        <td>{{ formatResponseStatus(alert.response_status) }}</td>
                                        <td>{{ getTeamName(alert.team_id) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <span v-else>No alerts</span>
                        </td>
                        <td style="vertical-align: top">
                            <table v-if="surveyAlerts.length" class="sub-table">
                                <thead>
                                    <tr>
                                        <th style="white-space: nowrap">Type</th>
                                        <th style="white-space: nowrap">Team Name</th>
                                        <th style="white-space: nowrap">Surveys</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(survey, index) in surveyAlerts" :key="index">
                                        <td>{{ formatType(survey.type) }}</td>
                                        <td>{{ getTeamName(survey.teamId) }}</td>
                                        <td>
                                            <ul>
                                                <li
                                                    v-for="(surveyTitle, surveyIndex) in survey.surveys"
                                                    :key="surveyIndex"
                                                >
                                                    {{ surveyTitle }}
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <span v-else>No alerts</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    props: {
        user: {
            type: Object,
            required: true,
        },
        teams: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            dashboardAlerts: [],
            surveyAlerts: [],
            sources: {
                facebook_pages: "Facebook",
                trip_advisor: "TripAdvisor",
                booking_com: "Booking.com",
                hotels_com: "Hotels.com",
                google: "Google",
                zoover: "Zoover",
                agoda: "Agoda",
                cheaptickets: "CheapTickets",
                ctrip: "CTrip",
                ebookers: "Ebookers.ie",
                expedia: "Expedia",
                goibibo: "Goibibo",
                holiday_check: "HolidayCheck",
                hotels_de: "Hotel.de",
                hrs: "HRS",
                orbitz: "Orbitz",
                priceline: "Priceline",
                travelocity: "Travelocity",
                venere: "Venere",
                wotif: "Wotif",
                lastminute: "lastminute.com",
                holiday_iq: "HolidayIQ",
                hotel_specials: "Hotelspecials.nl",
                weekendje_weg: "Weekendjeweg.nl",
                thefork: "thefork",
                hotels_nl: "Hotels.nl",
                hotelkamerveiling: "HotelKamerVeiling.nl",
                airbnb: "Airbnb",
                hoteliers_com: "Hoteliers.com",
                hotel_feedback: "HotelFeedback",
                exclusivi: "Exclusivi",
                top_hotels_ru: "TopHotels.ru",
                weg_de: "Weg.de",
                urlaub_de: "Ab-in-den-urlaub",
                tui_com: "Tui.com",
                check24_de: "Check24",
                atrapalo_com: "Atrapalo",
                yelp: "Yelp",
                voyage_prive: "Voyage Prive",
                itaka_pl: "Itaka.pl",
                travel_republic: "Travel Republic",
                corendon_nl: "Corendon.nl",
                foursquare: "FourSquare",
                opentable: "OpenTable",
                zomato: "Zomato",
                trustpilot: "Trustpilot",
                alpharooms: "Alpharooms",
                hotel_de: "Hotel.de",
                sunweb: "Sunweb",
                traveloka: "Traveloka",
                qunar: "Qunar",
                vrbo: "Vrbo",
                cruisecritic: "Cruise Critic",
                directbooking: "Direct Booking",
                halalbooking: "HalalBooking",
                tui_nl: "Tui.nl",
                otelpuan: "Otelpuan",
                cedok: "Cedok",
            },
        };
    },
    computed: {
        teamNames() {
            return this.teams.reduce((acc, team) => {
                acc[team.id] = team.name;
                return acc;
            }, {});
        },
    },
	watch: {
        'user.id': function (newVal, oldVal) {
            if (newVal !== oldVal) {
                this.loadAlerts();
            }
        },
    },
    methods: {
        loadAlerts() {
            this.getDashboardAlerts();
            this.getSurveyAlerts();
        },
        getSurveyAlerts() {
            axios
                .post(
                    `private/surveys/settings/getUserAlerts`,
                    {
                        userEmail: this.user.email,
                    },
                    {
                        baseURL: process.env.MIX_API_URL,
                        headers: {
                            Authorization: Spark.jwtToken,
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                    },
                )
                .then((response) => {
                    this.surveyAlerts = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching survey alerts:', error);
                });
        },
        getDashboardAlerts() {
            axios
                .get(`/api/admin/reviews/alerts/${this.user.id}`)
                .then((response) => {
                    this.dashboardAlerts = response.data;
                })
                .catch((error) => {
                    console.error('Error fetching rules:', error);
                });
        },
        getTeamName(teamId) {
            return this.teamNames[teamId] || 'Unknown Team';
        },
        getFormattedSources(sources) {
            if (sources) {
                try {
                    let sourcesArray = JSON.parse(sources);
                    return Array.isArray(sourcesArray)
                        ? sourcesArray.map(source => this.sources[source] || source).join(', ')
                        : this.sources[sources] || sources;
                } catch (error) {
                    console.error('Error parsing sources:', error);
                    return sources;
                }
            }
            return 'Any';
        },
        formatResponseStatus(status) {
            if (status) {
                try {
                    let statusArray = JSON.parse(status);
                    return Array.isArray(statusArray)
                        ? statusArray.map(s => this.formatStatusText(s)).join(', ')
                        : this.formatStatusText(status);
                } catch (error) {
                    console.error('Error parsing status:', error);
                    return status;
                }
            }
            return 'Any';
        },
        formatStatusText(status) {
            switch (status) {
                case 'has_response':
                    return 'Has Response';
                case 'no_comments':
                    return 'No Comments';
                case 'with_comments':
                    return 'With Comments';
                default:
                    return status;
            }
        },
        formatType(type) {
            return type.toUpperCase();
        },
    },
    mounted() {
        this.loadAlerts();
    },
};
</script>


<style scoped>
.table-responsive {
	margin: 20px 0;
	width: 100%;
	overflow-x: auto;
}

.table {
	width: 100%;
	margin-bottom: 0;
	color: #212529;
	border-collapse: collapse;
}

.table th,
.table td {
	padding: 0.75rem;
	vertical-align: top;
}

.table th {
	background-color: #f8f9fa;
	border-top: 1px solid #dee2e6;
	border-bottom: 1px solid #dee2e6;
}

.table td {
	border: 1px solid #dee2e6;
}

.table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(0, 0, 0, 0.05);
}

.sub-table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 5px;
}

.sub-table th,
.sub-table td {
	border: 1px solid #dee2e6;
	padding: 8px;
}

.sub-table th {
	background-color: #f1f1f1;
	font-weight: bold;
}
</style>
